import React from 'react'

const SectionTitle = ({title}) => {
  return (
    <h2 className='text-center m-10 text-4xl font-extrabold font-poppins bg-gradient-to-r from-rose-600 to-fuchsia-700 bg-clip-text text-transparent'>
    {title}
  </h2> )
}

export default SectionTitle